import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './TimeSlot.scss';

export const TimeSlot = ({ title, isChecked, isDisabled = false }) => (
  <div className={styles.Appointment_time__slot_holder}>
    <em
      className={classnames(styles.Appointment_time__slot, {
        [styles.Appointment_time__slot_checked]: isChecked,
        [styles.Appointment_time__slot_disabled]: isDisabled,
      })}
    >
      {title}
    </em>
  </div>
);

TimeSlot.propTypes = {
  title: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
};
